'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureGoogleAdWords;

var _scriptLoader = require('./script-loader.js');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureGoogleAdWords(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (config.preloaded) {
    var src = 'https://www.googleadservices.com/pagead/conversion_async.js';
    promise = (0, _scriptLoader2.default)({ src: src, globalName: 'google_trackConversion', stubType: 'function', window: window, document: document });
  }

  handlers.push(handleEvent.bind(null, config.id, config.mappings));

  return promise;
}

function handleEvent(conversionId, mappings, _ref2) {
  var type = _ref2.type,
      id = _ref2.id;

  if (type === 'track') {
    return (mappings || []).filter(function (mapping) {
      return mapping.evt === id;
    }).forEach(function (mapping) {
      window.google_trackConversion({
        google_conversion_id: conversionId,
        google_conversion_label: mapping.label,
        google_remarketing_only: false
      });
    });
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/google-adwords.js
// module id = 6
// module chunks = 0